import styled from "styled-components";
import { ClientSettingsToggleDefaultBox } from "./client-settings-toggle.default.box";
import { hexToRgba } from "../../../../../../themes/hex-to-rgba";

export const ClientSettingsToggleCasino777Box = styled(ClientSettingsToggleDefaultBox)`
    label {
        span {
            background-color: ${({ checked, theme }) => checked ? hexToRgba(theme.colors.brandPrimary, 0.3) : hexToRgba(theme.colors.brandSecondaryDark, 0.4)};

            &::before {
                    background-color: ${({ checked, theme }) => checked ? theme.colors.brandPrimary : theme.colors.brandSecondaryDark};
            }
        }
    }
`